<template>
  <div class="modal fade bd-example-modal-lg" id="accessgroupwindow" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" v-if="current">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
              Permisos de Usuario {{current.Description}}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="errors.length>0" class="alert alert-danger" role="alert">
            <div v-for="error of errors">
                {{error}}
            </div>
        </div>
        <div class="modal-body" v-if="current">
          <div class="form-row">
              <div class="col-md-3">
                  <div class="form-group">
                      <label for="Description" >Descripción</label>
                      <input v-model="current.Description" name="Description" class="form-control "
                      type="text" id="Description" >
                  </div>
              </div>
              <div class="col-md-3">
                  <div class="form-group">
                      <label for="RoleCode">Role Code</label>
                      <input v-model="current.RoleCode" name="RoleCode" class="form-control "
                      type="text" id="RoleCode" >
                  </div>
              </div>
              <div class="col-md-2">
                  <div class="form-check">
                      <input v-model="current.Closed" name="Closed" class="form-check-input" type="checkbox">
                      <label for="Closed" class="form-check-label">Cerrado</label>
                  </div>
              </div>
              <div class="col-md-3" style="padding-top: 24px;">
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="toggleJsonMode">
                      {{ jsonRawMode ? 'Vista Visual' : 'Editar JSON' }}
                  </button>
              </div>
          </div>
          <div class="form-row">
              <div class="col-md-12">
                  <div class="form-group">
                      <label for="Permissions">Permisos</label>
                      <div v-if="!jsonRawMode">
                          <jsonview :permissions.sync="current.permissions" :accessgroups="accessGroups"
                          :pjson.sync="current.Permissions" v-if="accessGroups" :id="current.id"></jsonview>
                      </div>
                      <div v-else>
                          <textarea v-model="rawJson" rows="15" class="form-control mt-2"
                              style="font-family: monospace; font-size: 12px; white-space: pre;"
                              @blur="applyRawJson"></textarea>
                          <small v-if="jsonError" class="text-danger">{{ jsonError }}</small>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" @click="save(current)">Guardar cambios</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Cerrar</button>
          <button type="button" class="btn btn-danger" @click="remove(current)">Eliminar</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import jsonview from '@/components/tools/JsonView'
export default {
    name: 'accessgroupwindow',
    props: ['endpoint', 'currentrecord', 'accessGroups'],
    components: {
      jsonview
    },
    data  () {
        return {
            current: null,
            errors: [],
            canEdit: false,
            canDelete: false,
            processing: false,
            fieldOptions: {},
            getInvalidClass: {},
            myfields: ['Description'],
            jsonRawMode: false,
            rawJson: '',
            jsonError: null,
        }
    },
    computed:{
    },
    created (){
    },
    mounted  () {
        this.current = _.cloneDeep(this.currentrecord);
        this.canEdit = app.canAccess(this.user, 'api','POST', this.endpoint)
        this.canDelete = app.canAccess(this.user, 'api','DELETE', this.endpoint)
        app.addEscapeKey(this, '#accessgroupwindow')
    },
    watch: {
        current: {
            handler (oldValue,newValue) {
                        if (oldValue && newValue) {
                            if (oldValue.Permissions!=newValue.Permissions) {
                                // `Permissions` puede venir como string (JSON) o como objeto (al crear uno nuevo)
                                try {
                                    if (typeof this.current.Permissions === 'string') {
                                        this.current.permissions = JSON.parse(this.current.Permissions || '{}')
                                    } else if (this.current.Permissions && typeof this.current.Permissions === 'object') {
                                        this.current.permissions = this.current.Permissions
                                    } else {
                                        this.current.permissions = {}
                                    }
                                } catch (e) {
                                    this.current.permissions = {}
                                }
                            }
                        }
                    },
                    deep: true,
        },
        currentrecord () {
            this.current = _.cloneDeep(this.currentrecord);
        },

    },
    methods: {
        save (record) {
            app.saveRecord(this, record, '#accessgroupwindow')
        },
        remove (record) {
            app.remove(this,record)
        },
        addError   (msg) {
            app.addError(this, msg)
        },
        toggleJsonMode () {
            if (!this.jsonRawMode) {
                // Entrando a modo raw: preparar el textarea con el JSON actual
                try {
                    if (typeof this.current.Permissions === 'string') {
                        this.rawJson = JSON.stringify(JSON.parse(this.current.Permissions || '{}'), null, 2)
                    } else if (this.current.Permissions && typeof this.current.Permissions === 'object') {
                        this.rawJson = JSON.stringify(this.current.Permissions, null, 2)
                    } else {
                        this.rawJson = JSON.stringify({}, null, 2)
                    }
                    this.jsonError = null
                    this.jsonRawMode = true
                } catch (e) {
                    this.rawJson = JSON.stringify({}, null, 2)
                    this.jsonError = 'JSON inválido en el registro actual'
                    this.jsonRawMode = true
                }
            } else {
                // Saliendo de modo raw: aplicar el JSON pegado; si falla, nos quedamos en raw
                const ok = this.applyRawJson()
                if (ok) this.jsonRawMode = false
            }
        },
        applyRawJson () {
            try {
                const text = (this.rawJson ?? '').trim()
                let parsed = {}
                if (text) parsed = JSON.parse(text)
                this.current.Permissions = JSON.stringify(parsed)
                this.current.permissions = parsed
                this.jsonError = null
                return true
            } catch (e) {
                this.jsonError = 'JSON inválido: ' + e.message
                return false
            }
        },
    }
}
</script>

